/* eslint-disable */
export function ObjectAssign() {
    const result = {};
    const { length } = arguments;
    let i = 0;
    while (i < length) {
        for (const key in arguments[i]) {
            if (arguments[i].hasOwnProperty(key)) {
                result[key] = arguments[i][key];
            }
        }
        i++;
    }
    return result;
}

export function htmlEncode(str) {
    return `${str}`
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&#39;')
        .replace(/"/g, '&quot;')
        .replace(/ /g, '&nbsp;')
        .replace(/=/g, '&#61;')
        .replace(/`/g, '&#96;');
}

export function throttledebounce(callback, duration) {
    let timeout;
    let start;
    return function() {
        const now = Date.now();
        if (timeout) {
            window.clearTimeout(timeout);
        }

        if (!start) {
            start = now;
        }

        if (now - start > duration) {
            callback.apply(this, arguments);
            start = now;
        } else {
            timeout = setTimeout(() => {
                timeout = null;
                callback.apply(this, arguments);
            }, duration);
        }
    };
}

const todayStamp = Math.floor(Date.now() / 1000 / 3600 / 24);
export function imageSourceAddTodayStamp(src) {
    if (!src) return '';
    const split = ~src.indexOf('?') ? '&' : '?';
    return `${src + split}date=${todayStamp}`;
}

export function treeLoop({ tree = [], callback = () => {}, depth = 0, parentNode }) {
    for (let i = 0; i < tree.length; i++) {
        callback({ node: tree[i], depth, parentNode });
        if (tree[i].children) {
            treeLoop({
                tree: tree[i].children,
                callback,
                depth: depth + 1,
                parentNode: tree[i]
            });
        }
    }
}

export function treeFlat(tree) {
    let result = [];
    for (let i = 0; i < tree.length; i++) {
        result.push(tree[i]);
        if (tree[i].children) {
            result = result.concat(treeLoop(tree[i].children));
        }
    }
    return result;
}
